import { DefaultMetricOptions, Goal, ID } from '@griply/types';

import { getSubGoals } from './get-sub-goals';

// Progress rolls sub-goal tasks up, so a metric goal needs its whole sub-tree loaded.
export const getGoalProgressGoalIds = (goals: Goal[]): ID[] => {
  const metricGoals = goals.filter(
    ({ metric }) => metric?.id === DefaultMetricOptions.CompletedTasks,
  );

  if (!metricGoals.length) {
    return [];
  }

  const ids = new Set<ID>();
  metricGoals.forEach((goal) => {
    ids.add(goal.id);
    getSubGoals(goal.id, { goals, recursive: true }).forEach(({ id }) =>
      ids.add(id),
    );
  });

  return [...ids];
};
